/**
 * Lightweight fire-and-forget visitor event tracker.
 * Uses `sendBeacon` where available so we don't block navigation on click.
 * Silently swallows errors — analytics must never break the UI.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function trackEvent(event, label, meta) {
  if (!event) return;
  try {
    const body = JSON.stringify({
      event,
      label: label || null,
      page_url: typeof window !== 'undefined' ? window.location.pathname : null,
      meta: meta || {},
    });
    const url = `${BACKEND_URL}/api/events/track`;
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return;
    }
    // Fallback: fetch with keepalive
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    // never let a tracking call break the UX
  }
}
